class CartNotification extends HTMLElement {
    constructor() {
        super()

        this.notification = document.getElementById('cart-notification')
        this.header = document.querySelector('sticky-header')
        this.onBodyClick = this.handleBodyClick.bind(this)

        this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close())
        this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
            closeButton.addEventListener('click', this.close.bind(this))
        )
    }

    open() {
        this.notification.classList.add('animate', 'active')
        this.animateChat()

        this.notification.addEventListener(
            'transitionend',
            () => {
                this.notification.focus()
                trapFocus(this.notification)
            },
            {once: true}
        )

        document.body.addEventListener('click', this.onBodyClick)
    }

    sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms))
    }

    close() {
        this.notification.classList.remove('active')
        document.body.removeEventListener('click', this.onBodyClick)

        removeTrapFocus(this.activeElement)
    }

    renderContents(parsedState) {
        this.cartItemKey = parsedState.key
        this.getSectionsToRender().forEach((section) => {
            document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.id],
                section.selector
            )
        })

        if (this.header) this.header.reveal()
        this.open()
    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-notification-product',
                selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
            },
            {
                id: 'cart-notification-button',
            },
            {
                id: 'cart-icon-bubble',
            },
        ]
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
    }

    handleBodyClick(evt) {
        const target = evt.target
        if (target !== this.notification && !target.closest('cart-notification')) {
            const disclosure = target.closest('details-disclosure, header-menu')
            this.activeElement = disclosure ? disclosure.querySelector('summary') : null
            this.close()
        }
    }

    setActiveElement(element) {
        this.activeElement = element
    }

    async animateChat() {
        const container = this
        const blocks = Array.from(container.querySelectorAll('.chat-block'))
        const bubble = container.querySelector('.chat-bubble')
        const CHATBUBBLE_HEIGHT = 42
        const GAP = 16
        const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

       
        blocks.forEach((block) => {
            block.classList.remove('is-visible')
            block.style.transform = 'translateY(0)'
        })

        let index = 0
        const visibleBlocks = []

        
        bubble.classList.add('is-visible')
        //await sleep(400)

        while (index < blocks.length) {
            const currentBlock = blocks[index]
            bubble.classList.add('is-visible')
            const pushUpAmount = currentBlock.offsetHeight + GAP

           
            let cumulativeOffset = CHATBUBBLE_HEIGHT + GAP
            for (let i = visibleBlocks.length - 1; i >= 0; i--) {
                const block = visibleBlocks[i]
                block.style.transform = `translateY(-${cumulativeOffset}px)`
                cumulativeOffset += block.offsetHeight + GAP
            }

            await sleep(400)

           
            bubble.classList.remove('is-visible')
            currentBlock.classList.add('is-visible')
            currentBlock.style.transform = 'translateY(0)' 
            visibleBlocks.push(currentBlock)

            
            let totalOffset = 0
            for (let i = visibleBlocks.length - 1; i >= 0; i--) {
                const block = visibleBlocks[i]
                if (i === visibleBlocks.length - 1) {
                    block.style.transform = 'translateY(0)'
                    totalOffset = block.offsetHeight + GAP
                } else {
                    
                    block.style.transform = `translateY(-${totalOffset}px)`
                    totalOffset += block.offsetHeight + GAP
                }
            }

            await sleep(1500)

            index++
        }

        bubble.classList.remove('is-visible')
    }
}

customElements.define('cart-notification', CartNotification)
